import { useRef, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useIsMount } from '../../hooks/useIsMount';
import { toMoney } from '../../helpers';
import styles from '../../styles/modules/building/BuildingObjectsTable.module.scss';

const getTitle = (t) => {
  switch (t) {
    case 1:
      return 'Однокомнатная';

    case 2:
      return 'Двухкомнатная';

    case 3:
      return 'Трехкомнатная';

    case 4:
      return 'Четырехкомнатная';

    default:
      return '';
  }
};

const BuildingObjectsTablePreview = ({ data, show, x, y }) => {
  const isMount = useIsMount();
  const parentEl = useRef();

  useEffect(() => {
    if (isMount) return;

    if (parentEl.current && window.innerWidth > 768) {
      const elParams = parentEl.current.getBoundingClientRect();

      const getPostionOfPreview = () => {
        return {
          left: x - elParams.width / 2,
          right: window.innerWidth - x - elParams.width / 2
        };
      };

      if (getPostionOfPreview().left - 12 <= 0) {
        /** When out of left line. */
        parentEl.current.style.left = `${x - elParams.width / 2 - (x - elParams.width / 2) + 12}px`;
      } else if (getPostionOfPreview().right - 12 <= 0) {
        /** When out of right line. */
        parentEl.current.style.left = `${
          x - elParams.width / 2 + (window.innerWidth - x - elParams.width / 2) - 12
        }px`;
      } else parentEl.current.style.left = `${x - elParams.width / 2}px`;

      if (y - elParams.height - 24 < 0) {
        parentEl.current.style.top = `${y + 12}px`;
      } else parentEl.current.style.top = `${y - elParams.height - 12}px`;
    }
  }, [x, y]);

  return show ? (
    <motion.div
      ref={parentEl}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className={styles.tablePreview}
    >
      <div className={styles.tablePreviewImage}>
        <img src={data.plan} alt="Планировка" width={300} />
      </div>
      <div className={styles.tablePreviewContent}>
        <div className={styles.tablePreviewTitle}>
          {data.studio ? 'Квартира-студия' : `${getTitle(data.rooms)} квартира`}
        </div>
        <div className={styles.tablePreviewSubtitle}>Стоимость от застройщика</div>
        <div className={styles.tablePreviewText}>Услуги компании бесплатно</div>
        <div className={styles.tablePreviewMoreContent}>
          <div className={styles.tablePreviewMoreItem}>
            <div className={styles.text}>Стоимость</div>
            <div className={styles.value}>{toMoney(data.price.value)} ₽</div>
          </div>
          <div className={styles.tablePreviewMoreItem}>
            <div className={styles.text}>Стоимость за м²</div>
            <div className={styles.value}>{toMoney(data.priceM2)} ₽</div>
          </div>
          <div className={styles.tablePreviewMoreItem}>
            <div className={styles.text}>Площадь</div>
            <div className={styles.value}>{data.area.value} м²</div>
          </div>
        </div>
      </div>
    </motion.div>
  ) : null;
};

export default BuildingObjectsTablePreview;
